import { render, staticRenderFns } from "./lowPriceRealTimeOperate.vue?vue&type=template&id=4905f57e&scoped=true"
import script from "./lowPriceRealTimeOperate.vue?vue&type=script&lang=js"
export * from "./lowPriceRealTimeOperate.vue?vue&type=script&lang=js"
import style0 from "./lowPriceRealTimeOperate.vue?vue&type=style&index=0&id=4905f57e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4905f57e",
  null
  
)

export default component.exports